import { Route, Routes } from "react-router-dom";
import './App.css';
import ProtectedRoute from "./components/Auth/ProtectedRoute";
import NavBar from "./components/Home/NavBar";
import SupaLogin from "./components/Login/SupaLogin";
import { MarksBulkImageUploadWrapper } from "./components/BulkImageUpload/MarksBulkImageUploadWrapper";
import { MarksSingleImageUploadWrapper } from "./components/SingleImageUpload/MarksSingleImageUploadWrapper";
import GeneratorWrapper from "./components/Generator/GeneratorWrapper";
import { ProductsProvider } from "./context/GeneratorContext";
import { SearchProductUploadWrapper } from "./components/SearchProductUpload/SearchProductUploadWrapper";
import { KrogerIntakeFormWrapper } from "./components/KrogerIntakeForm/KrogerIntakeFormWrapper";
import { SyndigoCreateProductWrapper } from "./components/SyndigoCreateProduct/SyndigoCreateProductWrapper";
import { UnderConstruction } from "./components/UnderConstruction/UnderConstruction";
import { ResetPasswordPageWrapper } from "./components/ResetPasswordPage/ResetPasswordPageWrapper";
import { UpcManagerWrapper } from "./components/UpcManager/UpcManagerWrapper";
import { CommodityCreatorWrapper } from "./components/CommodityCreator/CommodityCreatorWrapper";
import { SubCommodityCreator } from "./components/CommodityCreator/SubCommodityCreator/SubCommodityCreator";
import DemoWrapper from "./components/Demo/DemoWrapper";
import { SyndigoUploadWrapper } from "./components/SyndigoUpload/SyndigoUploadWrapper";
import { IntakeFormEmailsForm } from "./components/IntakeFormEmailsForm/IntakeFormEmailsForm";

const App = () => {
    return (
        <div className='min-width-screen'>
            <Routes>
                <Route path='/*' element={<NavBar />}>
                    <Route path='login' element={<> <SupaLogin /></>} />
                    <Route path='kroger-intake-form' element={<KrogerIntakeFormWrapper />} />
                    <Route path='construction' element={<> <UnderConstruction pageTitle="/upc-create" /> </>} />
                    <Route path='generator/*' element={<ProductsProvider> <GeneratorWrapper /> </ProductsProvider>} />
                    <Route element={<ProtectedRoute />}>
                        <Route path='profile/passwordReset' element={ <ResetPasswordPageWrapper /> } />
                        <Route path='syndigo-upload' element={<SyndigoUploadWrapper /> } />
                        <Route path='marks-single-image-upload' element={ <MarksSingleImageUploadWrapper /> } />
                        <Route path="marks-bulk-image-upload" element={ <MarksBulkImageUploadWrapper /> } />
                        <Route path="upc-search" element={ <SearchProductUploadWrapper /> } />
                        <Route path="upc-manager" element={ <UpcManagerWrapper />} />
                        <Route path="upc-create" element={ <SyndigoCreateProductWrapper /> } />
                        <Route path="commodity-creator" element={<CommodityCreatorWrapper />}>
                            <Route path="sub" element={<SubCommodityCreator />} />
                        </Route>
                        <Route path="intake-form-emails" element={<IntakeFormEmailsForm />} />
                    </Route>
                </Route>
                <Route path="/demo/*" element={<DemoWrapper />} />
            </Routes>
            <p className='text-xs text-right'>Version {process.env.REACT_APP_GIT_TAG}</p>
        </div>
    )
}

export default App;
